import {
  getNotFromSimpleFilter,
  getOperatorFromQueryFilter,
  getOperatorFromSimpleFilter,
} from '@/sections/insights/queryBuilder/entities/common/translators';
import type {
  SimpleFilter,
  SimpleFilterDefinition,
} from '@/sections/insights/queryBuilder/entities/types';
import type { QueryFilter } from '@/types';

/**
 * AWS Account ID filter definition
 * Free-text input for AWS account IDs like 123456789012
 */
export const AWSAccountID: SimpleFilterDefinition = {
  apiField: 'accountRef',
  uiField: 'Account ID',
  inputType: 'text',
  operators: ['is', 'is not', 'contains', 'starts with', 'ends with'],

  translateForUI: (queryFilter: QueryFilter): SimpleFilter => ({
    field: 'Account ID',
    operator: getOperatorFromQueryFilter(queryFilter),
    value: queryFilter.value as string | string[],
  }),

  translateForAPI: (simpleFilter: SimpleFilter): QueryFilter => ({
    field: 'accountRef',
    operator: getOperatorFromSimpleFilter(simpleFilter),
    value: simpleFilter.value,
    not: getNotFromSimpleFilter(simpleFilter),
  }),
};
